import React from 'react';
import { useSelector } from 'react-redux';

const SuperAdminDashboard = () => {
  const { user } = useSelector((state) => state.superAdmin);

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-theme-dark dark:text-theme-light mb-6">
          Welcome back, {user?.name || 'Super Admin'}!
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Dashboard Cards */}
          <div className="bg-white dark:bg-theme-dark p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold text-theme-dark dark:text-theme-light mb-2">
              Total Users
            </h2>
            <p className="text-4xl font-bold text-theme-primary">0</p>
          </div>

          <div className="bg-white dark:bg-theme-dark p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold text-theme-dark dark:text-theme-light mb-2">
              Active Sessions
            </h2>
            <p className="text-4xl font-bold text-theme-primary">0</p>
          </div>

          <div className="bg-white dark:bg-theme-dark p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold text-theme-dark dark:text-theme-light mb-2">
              System Status
            </h2>
            <p className="text-lg text-green-500">Online</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
